import * as React from 'react'

import { connect } from 'react-redux'

import { communicationToLoadableProps } from '../../project-utils'
import {
  ApplicationState,
  personalInformationEditRequest,
  personalInformationGetRequest,
  selectPersonalInformation,
  selectUserById,
  userGetRequest
}                                       from '../../redux'
import EditPersonalForm                 from '../forms/PersonalInformationEditForm'

const mstp = (state: ApplicationState) => {
  const { personalInformation } = state.account
  const accountId = personalInformation ? personalInformation.accountId : 0

  return {
    personalInformationGetCommunication:  personalInformationGetRequest.communicationSelector(state),
    personalInformationEditCommunication: personalInformationEditRequest.communicationSelector(state),
    personalInformation:                  selectPersonalInformation(state),
    user:                                 selectUserById(accountId)(state)
  }
}

const actions = {
  getPersonalInformation:  personalInformationGetRequest.actionCreator,
  editPersonalInformation: personalInformationEditRequest.actionCreator,
  getUser:                 userGetRequest.actionCreator
}

type EditPersonalInformationProps =
  ReturnType<typeof mstp>
  & typeof actions

class EditPersonalInformation extends React.Component<EditPersonalInformationProps> {
  public componentDidMount () {
    const { personalInformation } = this.props
    this.props.getPersonalInformation()

    if (personalInformation && personalInformation.accountId) {
      this.props.getUser(personalInformation.accountId)
    }
  }

  public render () {
    const {
      editPersonalInformation,
      personalInformationGetCommunication,
      personalInformationEditCommunication,
      personalInformation,
      user
    } = this.props

    return (
      <EditPersonalForm
        isCached={personalInformation}
        values={{ ...personalInformation, ...(user && { email: user.account.email }) }}
        onSubmit={editPersonalInformation}
        {...communicationToLoadableProps(personalInformationGetCommunication)}
        {...personalInformationEditCommunication}
      />
    )
  }
}

export default connect(
  mstp,
  actions,
)(EditPersonalInformation)



// WEBPACK FOOTER //
// ./src/components/environments/EditPersonalInformation.tsx